import { Flex, Text } from "@chakra-ui/react";
import Personas from "./personas";
import { useGSAP } from '@gsap/react';
import gsap from 'gsap'
import { useRef } from "react";
import { useTranslation } from "../../i18n/LanguageContext";

export default function Many() {

  const containerRef = useRef();
  const { t } = useTranslation();

  useGSAP(
    () => {
      gsap.from(".fade-in", {
        y: 50,
        opacity: '0',
        duration: 0.5,
        ease: "power2.inOut",
        stagger: 0.2,
        scrollTrigger: {
          trigger: ".fade-in",
        }
      });
    },
    { scope: containerRef }
  ); 

  return (
    <Flex
      as="section"
      aria-label={t("many.aria")}
      flexDirection={"column"}
      alignItems={"center"}
      ref={containerRef}
    >
      <Text
        as="h2"
        fontSize={"30px"}
        fontWeight={"500"}
        maxWidth={"500px"}
        textAlign={"center"}
        textwrap={"nowrap"}
        py={"50px"}
      >
          {t("many.title.prefix")} <br/>
        <Text as="span" color={"fill.coral"}>
          {t("many.title.personas")} 
        </Text>
        <Text as="span">
        &nbsp;{t("many.title.and")}&nbsp;
        </Text>
        <Text as="span" color={"fill.coral"}>
          {t("many.title.products")}
        </Text>
      </Text>
      <Personas />
      <Flex
        width={"100%"}
        gap={3}
        justifyContent={"center"}
        px={"20px"}
        py={"50px"}
        flexDirection={["column", 'row']}
      >
        <Flex
          as="article"
          flexDirection={"column"}
          alignItems={"center"}
          w={"100%"}
          maxW={"304px"}
          justifyContent={"center"}
          textAlign={"center"}
          className="fade-in"
        >
          <Text
            as="h3"
            color={"fill.coral"}
            fontSize={"25px"}
            fontWeight={"600"}
          >1</Text>
          <Text
            fontSize={"16px"}
            fontWeight={"500"}
            mt={2}
          >{t("many.point1.title")}</Text>
          <Text
            fontSize={"14px"}
            color={"text.medium.grey"}
            mt={"5px"}
          >{t("many.point1.desc")}</Text>
        </Flex>
        <Flex
          as="article"
          flexDirection={"column"}
          alignItems={"center"}
          w={"100%"}
          maxW={"304px"}
          justifyContent={"center"}
          textAlign={"center"}
          className="fade-in"
        >
          <Text
            as="h3"
            color={"fill.coral"}
            fontSize={"25px"}
            fontWeight={"600"}
          >2</Text>
          <Text
            fontSize={"16px"}
            fontWeight={"500"}
            mt={2}
          >{t("many.point2.title")}</Text>
          <Text
            fontSize={"14px"}
            color={"text.medium.grey"}
            mt={"5px"}
          >{t("many.point2.desc")}</Text>
        </Flex>
        <Flex
          as="article"
          flexDirection={"column"}
          alignItems={"center"}
          w={"100%"}
          maxW={"304px"}
          justifyContent={"center"}
          textAlign={"center"}
          className="fade-in"
        >
          <Text
            as="h3"
            color={"fill.coral"}
            fontSize={"25px"}
            fontWeight={"600"}
          >3</Text>
          <Text
            fontSize={"16px"}
            fontWeight={"500"}
            mt={2}
          >{t("many.point3.title")}</Text>
          <Text
            fontSize={"14px"}
            color={"text.medium.grey"}
            mt={"5px"}
          >{t("many.point3.desc")}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
